import { Link } from 'react-router-dom';

// Internal paths use the router; external URLs and #anchors use a plain <a>.
export default function SmartLink({ href = '/', children, ...rest }) {
  if (/^https?:\/\//i.test(href)) return <a href={href} target="_blank" rel="noopener noreferrer" {...rest}>{children}</a>;
  if (href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return <a href={href} {...rest}>{children}</a>;
  return <Link to={href} {...rest}>{children}</Link>;
}
